// リップルエフェクト用（PCでもクリック後にアニメーションを継続させる）
document.addEventListener('mousedown', function(e) {
    const btn = e.target.closest('.ripple-btn');
    if (btn) {
      // 既存のアニメーションがあればリセット
      btn.classList.remove('rippling');
      // リフローを強制してアニメーションを再開可能にする
      void btn.offsetWidth;
      btn.classList.add('rippling');
      
      // アニメーション終了時にクラスを削除
      const onEnd = () => {
        btn.classList.remove('rippling');
        btn.removeEventListener('animationend', onEnd);
      };
      btn.addEventListener('animationend', onEnd);
    }
  });